import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDocumentBadge24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconDocumentBadge24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M17 20.5H7A1.5 1.5 0 0 1 5.5 19v-1H11a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2H5.5V5A1.5 1.5 0 0 1 7 3.5h5.01v7h6.49V19a1.5 1.5 0 0 1-1.5 1.5M4 13.268V5a3 3 0 0 1 3-3h5.794a2 2 0 0 1 1.387.558l5.205 5.006A2 2 0 0 1 20 9.005V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3v-1.268A2 2 0 0 1 3 16v-1a2 2 0 0 1 1-1.732m14.5-4.269a.5.5 0 0 0-.153-.354l-4.836-4.65V9zM5 14.5h6a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDocumentBadge24);
